import { Box, Typography, Button, Divider } from '@mui/material';

/**
 * Renders raw screening result data inside MDForm's CustomModal.
 * Shows the data pretty-printed as JSON when parseable, otherwise as plain text.
 */
const ScreeningInfoModal = ({
        data,
        okLabel = 'OK',
        onOk,
}) => {
        const handleOk = () => {
                if (onOk) {
                        onOk();
                }
        };

        let display = '';
        if (data != null && data !== '') {
                try {
                        display = JSON.stringify(JSON.parse(data), null, 2);
                } catch (e) {
                        display = String(data);
                }
        }

        return (
                <Box id="scrngInfoMdlFrgmtId" sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box className="modal-body" sx={{ py: 2 }}>
                                {display ? (
                                        <Box
                                                component="pre"
                                                sx={{
                                                        m: 0,
                                                        maxHeight: '60vh',
                                                        overflow: 'auto',
                                                        fontFamily: 'monospace',
                                                        fontSize: '0.8125rem',
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word',
                                                }}
                                        >
                                                {display}
                                        </Box>
                                ) : (
                                        <Typography
                                                component="h6"
                                                variant="subtitle1"
                                                sx={{ color: '#828080', fontWeight: 400, m: 0 }}
                                        >
                                                No screening data available.
                                        </Typography>
                                )}
                        </Box>
                        <Divider />
                        <Box className="modal-footer" sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                                <Button
                                        type="button"
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        onClick={handleOk}
                                >
                                        {okLabel}
                                </Button>
                        </Box>
                </Box>
        );
};

export default ScreeningInfoModal;
